import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=238adb14&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=238adb14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238adb14",
  null
  
)

export default component.exports